import { useNavigate, useParams } from "react-router-dom";
import TcmProjectForm from "./TcmProjectForm";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import GetFetch from "../../hooks/GetFetch";
import { GetDateToday_dashes_reverse } from "../../util/GetDateToday";
import { LoadingIndicatorCircle } from "../../components/Loading";
import { URL_tcmProjectById } from "../TcmService";
import { ROUTE_TCM_PROJECTS } from "../Routes/Routes";

const EditTcmProject = () => {
    const { tcmProjectRecordId } = useParams();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page === ROUTE_TCM_PROJECTS.module) })
        if (!permissions?.filter(module => { return (module.Update) }).length > 0) {
            navigate(-1);
        }
        fetchRecord(tcmProjectRecordId);
    }, []);
    const fetchRecord = async (id) => {
        setIsLoading(true);
        const { Success, Message, Errors } = await GetFetch(`${URL_tcmProjectById}/${id}`);

        if (Success) {
            let copy = JSON.parse(JSON.stringify(Message));
            copy.UpdatedDate = GetDateToday_dashes_reverse();
            copy.UpdatedBy = user.email;
            setData(copy);
            // console.log("Message", Message)
        }
        else {
            setError(Errors[0].Message);
        }
        setIsLoading(false);
    }
    
    return (
        <>          
            <h4>Edit TCM Project</h4>
            {error && <p>Something went wrong.</p>}
            {isLoading && <LoadingIndicatorCircle message={`Loading TCM Project with ID ${tcmProjectRecordId}...`} />}
            {data &&
                <>
                    <div>
                        <span>Viewing TCM Project: <strong>{data.Id}</strong></span>
                    </div>
                    <TcmProjectForm
                        data={data}
                        isLoading={isLoading}
                        onReload={()=> fetchRecord(tcmProjectRecordId)}
                    />
                </>
            }
        </>
    )
}
export default EditTcmProject;